import { render, staticRenderFns } from "./EpcBadge.vue?vue&type=template&id=3f971386&"
import script from "./EpcBadge.vue?vue&type=script&lang=js&"
export * from "./EpcBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports